module.exports = __webpack_public_path__ + "img/MOBILE.2280e413.svg";